import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

import { db, auth } from "../firebase/config";

const getMembershipCollection = () => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  return collection(db, "gyms", uid, "membershipPlans");
};

export const getPlans = async () => {
  const snapshot = await getDocs(getMembershipCollection());

  return snapshot.docs.map((plan) => ({
    id: plan.id,
    ...plan.data(),
  }));
};

export const addPlan = async (data) => {
  return await addDoc(getMembershipCollection(), data);
};

export const deletePlan = async (id) => {
  const uid = auth.currentUser?.uid;

  if (!uid) {
    throw new Error("User not authenticated");
  }

  await deleteDoc(doc(db, "gyms", uid, "membershipPlans", id));
};
